/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contentreportresolve2Inputs */

const en_contentreportresolve2 = /** @type {(inputs: Contentreportresolve2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolve`)
};

const de_contentreportresolve2 = /** @type {(inputs: Contentreportresolve2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigen`)
};

/**
* | output |
* | --- |
* | "Resolve" |
*
* @param {Contentreportresolve2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contentreportresolve2 = /** @type {((inputs?: Contentreportresolve2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contentreportresolve2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contentreportresolve2(inputs)
	return de_contentreportresolve2(inputs)
});
export { contentreportresolve2 as "contentReportResolve" }